import * as angular from 'angular';
import { EnumService } from '../../../../../app.common/modules/common/services/enum.service';
import { BrandListItem } from '../../../core';

class BrandStatusComponent {
    static $inject = ['enumService', '$translate'];
    brand: BrandListItem;

    brandStatus = this.enumService.ClassificationCategoryBrandStatus;
    htmlTooltip = {
        awaitingApproval: this.$translate.instant('this_brand_is_waiting_approval'),
        rejected: this.$translate.instant('this_brand_was_rejected')
    };

    constructor(private enumService: EnumService, private $translate: angular.translate.ITranslateService) {
    }

    isPending() {
        return this.brand.Status === this.brandStatus.Pending;
    }

    isRejected() {
        return this.brand.Status === this.brandStatus.Rejected;
    }
}

angular.module('naut').component('brandStatus', {
    template: require('./brandStatus.html'),
    controller: BrandStatusComponent,
    controllerAs: '$ctrl',
    bindings: {
        brand: '<'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/brands/components/brandStatus/brandStatus.component.ts